/*
 * Created on Wed Oct 11 2023 4:56:55 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

import apiClient, { API_ENDPOINTS, executeApiRequest, rejectWithError } from "api";
import keys from "config/keys.jsx";

const { payment, transaction } = API_ENDPOINTS;

const rejectTransactionError = (error, label) => rejectWithError(error, label);

export const findTransactions = async (criteria) => {
    try {
        return await apiClient.post(transaction.find, criteria);
    } catch (error) {
        return rejectTransactionError(error, "Error finding transactions");
    }
};

export const createTransaction = async (transactionPayload) => {
    try {
        return await apiClient.post(transaction.create, transactionPayload);
    } catch (error) {
        return rejectTransactionError(error, "Error creating transaction");
    }
};

export const processRefund = async (refundPayload) => {
    try {
        return await executeApiRequest(keys.PAYMENT_URL, payment.refund, {
            method: "POST",
            payload: refundPayload,
            credentials: "same-origin",
            skipAuth: true
        });
    } catch (error) {
        return rejectTransactionError(error, "Error processing refund");
    }
};
